export default {
  setLastMedia(state, data) {
    state.lastMedia = data;
  },
  setVideoLastMedia(state, data) {
    state.videoLastMedia = data;
  },
  setAudioLastMedia(state, data) {
    state.audioLastMedia = data;
  },
  setPicLastMedia(state, data) {
    state.picLastMedia = data;
  },

  setChooseMedia(state, data) {
    state.chooseMedia = data;
  },

  setMoreMedia(state, data) {
    state.moreMedia = data;
  },

  setTabItems(state, data) {
    state.tabItems = data;
  },

  setMoreViewMedia(state, data) {
    state.moreViewMedia = data;
  },

  setSimilarMedia(state, data) {
    state.similarMedia = data;
  },

  setOneMedia(state, data) {
    state.oneMedia = data;
  },

  setComments(state, data) {
    state.comments = data;
  },
  setCommentsTotal(state, data) {
    state.commentsTotal = data;
  },

  setLiks(state, data) {
    state.likes = data;
  },

  setReport(state, data) {
    state.report = data;
  },

  setAudioBannerRight(state, data) {
    state.audioBannerRight = data;
  },
  setAudioBannerLeft(state, data) {
    state.audioBannerLeft = data;
  },

  setLoadBtn(state, data) {
    state.loadBtn = data;
  },
};
